import { Style } from './Styles';
import React from 'react';
import { LayerRules, RuleName, SymbolSVG } from '../components/Catalog/ArbreCapesElements';
import { Image, Svg, Path, Text, Polygon, Circle, Polyline, View } from '@react-pdf/renderer';
import $j from 'jquery';
import SLDParser from 'geostyler-sld-parser';
import { toast } from 'react-toastify';
import { getLayerBbox } from '../components/Utils/MapUtils';
import { getTranslatedKey } from '../components/Utils/TranslateUtils';

const triangleShape = <polygon points="0 , 10 10 , 10 5 , 0 0 , 10"></polygon>;
const starShape = (
  <polygon points="350 , 75 379 , 161 469 , 161 397 , 215 423 , 301 350 , 250 277 , 301 303 , 215 231 , 161 321 , 161 350 , 75"></polygon>
);
const xShape = <polygon points="0 , 0 25 , 0 50 , 35 75 , 0 100 , 0 65 , 50 100 , 100 75 , 100 50 , 65 25 , 100 0 , 100 35 , 50 0 , 0"></polygon>;
const crossShape = <polygon points="4 , 0 6 , 0 6 , 4 10 , 4 10 , 6 6 , 6 6 , 10 4 , 10 4 , 6 0 , 6 0 , 4 4 , 4 4 , 0"></polygon>;

const triangleShapePDF = <Polygon points="0 , 10 10 , 10 5 , 0 0 , 10"></Polygon>;
const starShapePDF = (
  <Polygon points="350 , 75 379 , 161 469 , 161 397 , 215 423 , 301 350 , 250 277 , 301 303 , 215 231 , 161 321 , 161 350 , 75"></Polygon>
);

const xShapePDF = <Polygon points="0 , 0 25 , 0 50 , 35 75 , 0 100 , 0 65 , 50 100 , 100 75 , 100 50 , 65 25 , 100 0 , 100 35 , 50 0 , 0"></Polygon>;
const crossShapePDF = <Polygon points="4 , 0 6 , 0 6 , 4 10 , 4 10 , 6 6 , 6 6 , 10 4 , 10 4 , 6 0 , 6 0 , 4 4 , 4 4 , 0"></Polygon>;

let svgImg = new window.Image();
svgImg.crossOrigin = 'Anonymous';

export class Layer {
  constructor(Layer, external, temporal, userWMS) {
    this.name = Layer?.Name ? (typeof Layer?.Name === 'string' ? Layer?.Name : Layer?.Name['#text']) : undefined; //nombre de la capa
    this.title = Layer?.Title ? (typeof Layer?.Title === 'string' ? Layer?.Title : Layer?.Title['#text']) : undefined; //titulo de la capa
    this.abstract = Layer?.Abstract ? (typeof Layer?.Abstract === 'string' ? Layer?.Abstract : Layer?.Abstract['#text']) : undefined; //abstract de la capa
    this.styleList = Layer?.StyleList; //json con los estilos, permite diferenciar entre capas con 1 estilo (string) y con mas de uno (array)
    this.layerList = Layer?.Layer; //json con las capas hija, permite diferenciar entre capas con 1 hijo (string) y con mas de uno (array)
    this.layers = []; //array con las capas hija
    this.styles = []; //array con los estilos de la capa
    this.rules = [];
    this.consultable = Layer?.queryable || undefined;
    this.rulesPDF = [];
    this.styleSelected = 0; //estilo seleccionado (por defecto es el primero)
    this.extension = undefined; // extension (se usa para exportar la capa)
    this.namespace = undefined; // namespace
    this.indexUUID = undefined; // uuid (se usa para exportar la capa)
    this.indexURL = undefined; // url (se usa para exportar la capa)
    this.OLLayer = undefined; //capa de open layers que se usa para pintar en el mapa
    this.OnlineResource = undefined; //url de la capa externa (solo para las externas)
    this.external = external; //booleano de si es un wms externo
    this.isInfoEnabled = true; //booleano para saber si el boton de informacion de la capa está activo o no
    this.scale = false; // booleano que indica si la capa tiene escala
    this.error = false;
    this.imgUrl = '';
    this.checked = false;
    this.userWMS = userWMS;
    this.shown = true;
    this.temporal = temporal;
    this.visible = true;
    this.expanded = false;
    this.filtresOpen = false;
    this.statsOpen = false;
    this.editOpen = false;
    this.dragging = false;
    this.transPopUpOpen = false;
    this.exportOpen = false;
    this.stylesOpen = false;
    this.isRaster = false;
    this.onRange = true;
    this.ajaxRequests = {};
    this.pdfScaleRules = [];
    this.bbox = undefined;
    this.color = '#febf00';
    this.kml = false;
    this.accessType = '';
    this.size = undefined;
    this.setStyles(); //inicializar los estilos
    this.setChildLayers(); //inicializar las capas hija
    this.setExtension(Layer); //inicializar extension
    this.setIndexUUID(Layer); //inicializar index uuid
    this.setIndexURL(Layer); //inicializar index url
    this.setOnlineResource(Layer); // inicializar onlineResource
  }

  setTempBbox = () => {
    const features = this.getOLLayer().getSource().getFeatures();
    let bbox = '';
    features.forEach((feature) => {
      let geometria = feature.getGeometry();
      if (geometria !== undefined) {
        if (bbox === '') {
          bbox = geometria.getExtent();
        } else {
          let aux = '';
          aux = geometria.getExtent();
          if (aux[0] < bbox[0]) bbox[0] = aux[0];
          if (aux[1] < bbox[1]) bbox[1] = aux[1];
          if (aux[2] > bbox[2]) bbox[2] = aux[2];
          if (aux[3] > bbox[3]) bbox[3] = aux[3];
        }
      }
    });
    this.bbox = bbox;
  };

  /**
   * @desc funcion para inicializar las capas hija
   */
  setChildLayers = (childLayers) => {
    if (childLayers !== undefined) {
      this.layerList = childLayers;
      for (let i = 0; i < childLayers.length; ++i) {
        this.layers.push(childLayers[i]);
      }
    } else {
      for (var i = 0; this.hasChilds() && i < this.getNumChilds(); ++i) {
        if (!Array.isArray(this.layerList)) this.layers.push(new Layer(this.layerList, this.external, this.temporal));
        else this.layers.push(new Layer(this.layerList[i], this.external, this.temporal));
      }
    }
  };
  /**
   * @desc funcion para asignar la bbox de la layer
   */
  setBbox = async (layer, capabilities) => {
    let bbox = await getLayerBbox(layer, capabilities);
    this.bbox = bbox;
  };

  getBbox = () => {
    return this.bbox;
  };
  /**
   * @desc funcion para asignar si tiene error
   */
  setError = (error) => {
    this.error = error;
  };

  /**
   * @desc funcion para obtener si tiene error
   */
  hasError = () => {
    return this.error;
  };

  /**
   * @desc funcion para obtener las capas hija
   */
  getChildLayers = () => {
    return this.layers;
  };

  /**
   *
   * @desc funcion para saber si es externa
   */
  isExternal = () => {
    return this.external;
  };

  /**
   *
   * @param {*} external
   * @desc funcion para asignar si la capa es externa
   */
  setExternal = (external) => {
    this.external = external;
  };

  /**
   *
   * @param {*} temporal
   * @desc funcion para asignar si la capa es temporal
   */
  setTemporal = () => {
    this.temporal = true;
  };

  /**
   *
   * @desc funcion para saber si es temporal
   */
  isTemporal = () => {
    return this.temporal;
  };

  /**
   * @desc funcion para asignar el filename
   */
  setFileName = (fileName) => {
    this.setExternal(true);
    this.filename = fileName;
  };

  /**
   *
   * @desc funcion para obtener el filename
   */
  getFileName = () => {
    return this.filename;
  };

  /**
   * @param id posición de la capa en el array de capas hijas
   * @desc funcion para obtener una capa hija en concreto
   */
  getChildLayer = (id) => {
    return this.layers[id];
  };

  /**
   * @param enabled booleano
   * @desc funcion para activar/desactivar la info de la capa
   */
  setInfoEnabled = (enabled) => {
    this.isInfoEnabled = enabled;
    if (window.innerWidth < 464) {
      enabled ? toast.info(getTranslatedKey('infoTrue')) : toast.info(getTranslatedKey('infoFalse'));
    }
  };

  /**
   *
   * @desc funcion para saber si la info de la capa esta activa o no
   */
  hasInfoEnabled = () => {
    return this.isInfoEnabled;
  };

  /**
   *
   * @desc función para obtener el total de capas hija
   */
  getNumChilds = () => {
    if (this.layerList !== undefined) {
      if (Array.isArray(this.layerList)) return this.layerList.length;
      else return 1;
    }
  };

  /**
   *
   * @desc función que devuelve si la capa tiene hijas o no
   */
  hasChilds = () => {
    return this.layerList !== undefined;
  };

  /**
   * @desc funcion para asignar el titulo de la capa
   */
  setTitle = (title) => {
    this.title = title;
  };

  /**
   *
   * @param {*} Style
   * @desc funcion para asignar un estilo a la capa
   */
  setStyle = (Style) => {
    this.styles.push(Style);
  };

  /**
   * @desc funcion para asignar la url del servicio externo
   */
  setOnlineResource = (Layer) => {
    if (typeof Layer === 'string') this.OnlineResource = Layer;
    if (Layer && Layer.Server && Layer.Server.OnlineResource) {
      if (Layer.Server.OnlineResource['@attributes'] !== undefined) {
        let atributs = Layer.Server.OnlineResource['@attributes'];
        this.OnlineResource = atributs['xlink:href'];
      } else {
        this.OnlineResource = Layer.Server.OnlineResource['xlink:href'];
      }
    }
    if (this.OnlineResource && !this.OnlineResource.startsWith('/')) {
      this.external = true;
    }
  };

  /**
   *
   * @desc funcion para obtener la url del servicio externo
   */
  getOnlineResource = () => {
    if (this.OnlineResource !== undefined) return this.OnlineResource;
  };

  /**
   * @desc funcion para asignar si la capa es publica o privada
   */
  setAccessType = (Layer) => {
    if (this.getOnlineResource()) {
      const onlineResource = this.getOnlineResource();
      const privateEndpoints = ['/owsseg', '/owssec', '/RVC/ows', '/ATC/ows'];

      this.accessType = privateEndpoints.some((endpoint) => onlineResource.startsWith(endpoint)) ? 'privada' : 'publica';
    }
  };

  /**
   * @desc funcion para obtener la condicion de la capa (publica o privada)
   */
  getAccessType = () => {
    if (this.accessType !== '') return this.accessType;
  };

  /**
   * @desc funcion para asignar el peso de la capa
   */
  setSize = (layer) => {
    if (layer && layer.Extension) {
      this.size = layer.Extension.Size ? layer.Extension.Size : 0;
    } else {
      this.size = 0;
    }
  };

  /**
   * @desc funcion para obtener el peso de la capa
   */
  getSize = () => {
    return this.size;
  };

  /**
   *
   * @desc función para obtener el nombre de la capa
   */
  getName = () => {
    return this.name;
  };

  /**
   *
   * @desc funcion para asignar el nombre de la capa
   */
  setName = (name) => {
    this.name = name;
  };

  /**
   *
   * @desc función para obtener el titulo de la capa
   */
  getTitle = () => {
    return this.title;
  };

  /**
   *
   * @desc función para obtener el titulo de la capa
   */
  getAbstract = () => {
    return this.abstract;
  };

  /**
   *
   * @desc funcion para saber si tiene metadatos
   */
  hasMetadata = () => {
    return typeof this.getIndexURL() !== 'undefined' || typeof this.getIndexUUID() !== 'undefined';
  };

  /**
   *
   * @param {*} Layer
   * @desc funcion para asignar extension a una layer
   */
  setExtension = (Layer) => {
    if (Layer && Layer.Extension) this.extension = Layer.Extension;
    this.setNamespace(Layer);
    this.setProperties(Layer);
    this.setSize(Layer);
  };

  /**
   *
   * @desc funcion para obtener la extension de una layer
   */
  getExtension = () => {
    return this.extension;
  };

  /**
   *
   * @param {*} Layer
   * @desc funcion para asignar namespace a una layer
   */
  setNamespace = (Layer) => {
    if (this.extension !== undefined && Layer && Layer.Extension && Layer.Extension.Namespace) this.namespace = Layer.Extension.Namespace;
  };

  /**
   * @desc funcion para obtener el namespace de una layer
   */
  getNamespace = () => {
    if (this.extension !== undefined) return this.namespace;
  };

  /**
   *
   * @param {*} Layer
   * @desc funcion para asignar las properties de una layer
   */
  setProperties = (Layer) => {
    if (this.extension !== undefined && Layer && Layer.Extension && Layer.Extension.Property) this.properties = this.extension.Property;
  };

  /**
   * @desc funcion para obtener  las properties de una layer
   */
  getProperties = () => {
    if (this.extension !== undefined) return this.properties;
  };

  /**
   *
   * @param {*} Layer
   * @desc funcion para asignar el indexUUID a una layer
   */
  setIndexUUID = (Layer) => {
    if (Layer && Layer.Extension && Layer.Extension.MetadataUUID) this.indexUUID = Layer.Extension.MetadataUUID;
  };

  /**
   *
   * @param {*} Layer
   * @desc funcion para asignar el indexURL a una layer
   */
  setIndexURL = (Layer) => {
    if (Layer && Layer.Extension && Layer.Extension.MetadataURL) this.indexURL = Layer.Extension.MetadataURL;
  };

  /**
   *
   * @desc funcion para obtener el indexUUID
   */
  getIndexUUID = () => {
    return this.indexUUID;
  };

  /**
   *
   * @desc funcion para obtener el indexURL
   */
  getIndexURL = () => {
    return this.indexURL;
  };

  /**
   *
   * @param {*} OLLayer
   * @desc funcion para asignar una capa de openlayers a la capa
   */
  setOLLayer = (OLLayer) => {
    this.OLLayer = OLLayer;
  };

  /**
   *
   * @desc funcion para obtener la layer de openlayers de la capa
   */
  getOLLayer = () => {
    return this.OLLayer;
  };

  /**
   *
   * @desc función que devuelve si la capa tiene estilos o no
   */
  hasStyles = () => {
    return this.styleList && this.styleList !== undefined && this.styleList.Style && this.styleList.Style.length > 0;
  };

  /**
   *
   * @desc función para saber si la capa es raster
   */
  isRasterLayer = () => {
    return this.isRaster;
  };

  isOnRange = () => {
    return this.onRange;
  };

  setIsOnRange = (bool) => {
    this.onRange = bool;
  };

  /**
   *
   * @desc función que devuelve el número de estilos de la capa
   */
  getNumStyles = () => {
    if (this.hasStyles()) return this.styleList.Style.length;
    else return 0;
  };

  /**
   *
   * @desc función que inicializa los estilos de la capa
   */
  setStyles = () => {
    if (!this.external) {
      for (let i = 0; this.hasStyles() && i < this.styleList.Style.length; ++i) {
        this.styles.push(new Style(this.styleList.Style[i], this.isRaster));
      }
    }
  };

  /**
   *
   * @desc función para obtener los estilos de la capa
   */
  getStyles = () => {
    return this.styles;
  };

  /**
   *
   * @desc función que devuelve el índice del array del estilo seleccionado
   */
  getStyleSelected = () => {
    return this.styleSelected;
  };

  /**
   *
   * @desc función para actualizar el estilo seleccionado
   */
  setStyleSelected = (newStyleSelected) => {
    this.styleSelected = newStyleSelected;
  };

  /**
   *
   * @desc función para obtener el estilo seleccionado
   */
  getCurrentStyle = () => {
    if (this.hasStyles()) return this.styles[this.getStyleSelected()];
    else return undefined;
  };

  /**
   *
   * @desc función para obtener un estilo a través de su identificador en el array
   */
  getStyle = (id) => {
    return this.styles[id];
  };

  /**
   *
   * @desc función para obtener el identificador de un estilo a través de su nombre
   */
  getStyleByName = (name) => {
    for (let i = 0; i < this.getNumStyles(); ++i) {
      let currentName = this.getStyle(i).getName() !== undefined ? this.getStyle(i).getName() : this.getTitle();
      if (currentName === name) {
        return i;
      }
    }
  };

  /**
   *
   * @desc función para obtener, si existe, el parametro MetadataUUID de la capa
   */
  getMetadataUUID = () => {
    return this.indexUUID;
  };

  /**
   *
   * @desc función para obtener, si existe, el parametro MetadataURL de la capa
   */
  isMetadataURL = () => {
    return this.indexURL;
  };

  /**
   *
   * @desc funcion para saber si la capa esta checkeada en el catalogo
   */
  isChecked = () => {
    return this.checked;
  };
  /**
   *
   * @desc funcion para saber si la capa es consultable
   */
  isConsultable = () => {
    return this.consultable;
  };

  /**
   *
   * @desc funcion para cambiar si esta checkeada o no en el catalogo
   */
  setChecked = (isChecked) => {
    this.checked = isChecked;
  };

  /**
   *
   * @desc funcion para saber si se esta mostrando o no en el catalogo (filtrada)
   */
  isShown = () => {
    return this.shown;
  };

  /**
   *
   * @param {*} isShown
   * @desc funcion para cambiar si se esta mostrando o no en el catalogo (filtrada)
   */
  setShown = (isShown) => {
    this.shown = isShown;
  };

  setScale = (bool) => {
    this.scale = bool;
  };

  hasScale = () => {
    return this.scale;
  };

  currentStyleHasScale = () => {
    const rules = this.getCurrentStyle().rules;
    if (rules.length > 1) {
      return this.getCurrentStyle().rules.some((rule) => {
        return rule.MaxScaleDenominator;
      });
    } else {
      return Boolean(rules.MaxScaleDenominator);
    }
  };

  isVisible = () => {
    return this.visible;
  };

  setVisible = (isVisible) => {
    this.visible = isVisible;
  };

  isDragging = () => {
    return this.dragging;
  };

  setDragging = (isDragging) => {
    this.dragging = isDragging;
  };

  isTransPopUpOpen = () => {
    return this.transPopUpOpen;
  };

  setTransPopUpOpen = (isTransPopUpOpen) => {
    this.transPopUpOpen = isTransPopUpOpen;
  };

  isExpanded = () => {
    return this.expanded;
  };

  setExpanded = (isExpanded) => {
    this.expanded = isExpanded;
  };

  isExportOpen = () => {
    return this.exportOpen;
  };

  setExportOpen = (exportOpen) => {
    this.exportOpen = exportOpen;
  };

  isStylesOpen = () => {
    return this.stylesOpen;
  };

  setStylesOpen = (stylesOpen) => {
    this.stylesOpen = stylesOpen;
  };

  isFiltresOpen = () => {
    return this.filtresOpen;
  };
  setFiltresOpen = (bool) => {
    this.filtresOpen = bool;
  };
  isEditOpen = () => {
    return this.editOpen;
  };
  setEditOpen = (bool) => {
    this.editOpen = bool;
  };
  isStatsOpen = () => {
    return this.statsOpen;
  };
  setStatsOpen = (bool) => {
    this.statsOpen = bool;
  };

  isKML = () => {
    return this.kml;
  };
  setKML = () => {
    this.kml = true;
  };
  /**
   *
   * @desc función booleana para saber si una layer tiene layers hijas o reglas para mostrar
   */
  hasChildsOrRules = () => {
    return (
      (this.getChildLayers() !== undefined && this.getNumChilds() > 0) || //es capa con hijas
      (this.hasStyles() &&
        this.getCurrentStyle() !== undefined &&
        this.getCurrentStyle().getNumRules() !== undefined &&
        this.getCurrentStyle().getNumRules() > 1) || //es capa con mas de una regla de estilos
      (this.hasStyles() && this.getCurrentStyle() !== undefined && this.isRasterLayer()) //es capa raster (tienen todas las reglas metidas en una rule)
    );
  };

  setColor = (color) => {
    this.color = color;
  };
  getColor = () => {
    return this.color;
  };

  /**
   * @param color
   * @param type
   * @desc funcion para crear el icono de la leyenda de capas temporales
   */
  setTemporalStyle = (type, isPDF) => {
    let style;
    if (type === 'Punt') {
      style = isPDF ? (
        <Svg width="16" height="16" viewBox="0 0 20 20" style={{ display: 'block', marginTop: 5, marginRight: 6 }}>
          <Circle
            cx="10"
            cy="10"
            r="3"
            fill={this.color}
            fillOpacity="1"
            stroke={this.color}
            strokeOpacity="1"
            strokeWidth="0"
            strokeLinecap="round"
            strokeLinejoin="round"></Circle>
          ;
        </Svg>
      ) : (
        <svg width="20" height="20" viewBox="0 0 20 20" style={{ display: 'block', marginTop: '5px', marginRight: '6px' }}>
          <circle
            cx="10"
            cy="10"
            r="3"
            fill={this.color}
            fillOpacity="1"
            stroke={this.color}
            strokeOpacity="1"
            strokeWidth="0"
            strokeLinecap="round"
            strokeLinejoin="round"></circle>
          ;
        </svg>
      );
    } else if (type === 'Línia') {
      style = isPDF ? (
        <Svg width="16" height="16" viewBox="0 0 20 20" style={{ display: 'block', marginTop: 5, marginRight: 10 }}>
          <Polyline
            points="2,13,7,7,13,13,18,7"
            stroke={this.color}
            fill="none"
            strokeOpacity="1"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </Svg>
      ) : (
        <svg width="20" height="20" viewBox="0 0 20 20" style={{ display: 'block', marginTop: 5, marginRight: 10 }}>
          <polyline
            points="2,13,7,7,13,13,18,7"
            stroke={this.color}
            fill="none"
            strokeOpacity="1"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    } else if (type === 'Polígon') {
      style = isPDF ? (
        <Svg width="16" height="16" viewBox="0 0 20 20" style={{ display: 'block', marginTop: 5, marginRight: 6 }}>
          <Path d=" M 2,14 4,16 16,16 18,14 18,6 16,4 4,4 2,6 2,14 z" fillRule="evenodd" fillOpacity="1" fill={this.color} stroke="none"></Path>
        </Svg>
      ) : (
        <svg width="20" height="20" viewBox="0 0 20 20" style={{ display: 'block', marginTop: '5px', marginRight: '6px' }}>
          <path d=" M 2,14 4,16 16,16 18,14 18,6 16,4 4,4 2,6 2,14 z" fillRule="evenodd" fillOpacity="1" fill={this.color} stroke="none"></path>
        </svg>
      );
    }
    return style;
  };

  // Función para verificar si una petición ya se ha realizado
  checkAjaxRequest = (url) => {
    // Devuelve verdadero si la petición ya se ha realizado
    return this.ajaxRequests[url] && this.ajaxRequests[url].readyState !== 4;
  };

  /**
   *
   * @param {*} styleID
   * @param {*} layer
   * @param {*} setRules
   * @param {*} isPDF
   * @desc funcion para generar y obtener el sld de un estilo
   */
  generateUIStyle = (styleID, layer, setRules, isPDF) => {
    //si no tiene el SLD, se crea y se vuelve a llamar a la función
    let self = this;
    let style = layer.getStyle(styleID);
    if (style !== undefined) {
      let url = style.getSLDUrl(layer, styleID);

      if (!style.hasSLDXml(styleID) || style.getSLDXml(styleID) === 'error') {
        // Si no tiene sld definido, hace una petición ajax para obtener el SLD del servidor

        if (this.checkAjaxRequest(url)) {
          return;
        }

        this.ajaxRequests[url] = $j
          .ajax({
            url: url,
            dataType: 'text'
          })
          .done(function (data) {
            //una vez tiene el sld, se añade al objeto de estilo y se hace una recursiva
            style.setSLDXml(data, styleID);
            self.generateUIStyle(styleID, layer, setRules, isPDF);
          })
          .fail(function () {
            if (!style.hasSLDXml(styleID)) style.setSLDXml('error', styleID);
            else style.setSLDXml('error2', styleID);
            return;
          })
          .always(function () {
            delete self.ajaxRequests[url];
          });

        return;
      }

      //una vez tiene el sld, se parsea, se actualiza el state y se crean las reglas del estilo
      const parser = new SLDParser();
      let xml = style.getSLDXml(styleID);
      if (xml !== 'error2') {
        //comprobamos si tiene wellKnownName y si no tiene se lo creamos en círuclo para que haga un punto
        const domParser = new DOMParser();
        const xmlDoc = domParser.parseFromString(xml, 'text/xml');

        const markElements = xmlDoc.getElementsByTagNameNS('http://www.opengis.net/sld', 'Mark');
        for (const markElement of markElements) {
          const wellKnownNameElement = markElement.getElementsByTagNameNS('http://www.opengis.net/sld', 'WellKnownName')[0];
          if (!wellKnownNameElement) {
            const newWellKnownNameElement = xmlDoc.createElementNS('http://www.opengis.net/sld', 'WellKnownName');
            newWellKnownNameElement.textContent = 'circle';
            markElement.appendChild(newWellKnownNameElement);
          }
        }

        //Sacamos a mano la opacidad, ya que la librería no lo hace
        const ruleElements = xmlDoc.getElementsByTagNameNS('http://www.opengis.net/sld', 'Rule');
        const fillOpacities = Array.from(ruleElements).map((ruleElement) => {
          let fillOpacityElement;
          const fillElement = ruleElement.getElementsByTagNameNS('http://www.opengis.net/sld', 'Fill')[0];
          if (fillElement) {
            fillOpacityElement = fillElement.querySelector('CssParameter[name="fill-opacity"]');
          }
          if (fillOpacityElement) {
            return fillOpacityElement.textContent || fillOpacityElement.innerText;
          } else {
            return undefined;
          }
        });

        const serializer = new XMLSerializer();
        const modifiedXmlData = serializer.serializeToString(xmlDoc);
        parser
          .readStyle(modifiedXmlData)
          .then(({ output: sldObject }) => {
            if (sldObject.rules) {
              sldObject.rules.forEach((rule, index) => {
                if (rule.symbolizers) {
                  rule.symbolizers.forEach((symbolizer) => {
                    if (symbolizer.kind === 'Fill') {
                      symbolizer.fillOpacity = fillOpacities[index];
                    }
                  });
                }
              });
            }
            setRules();
            this.createRule(sldObject, styleID, layer, isPDF);
          })
          .catch((error) => {});
      } else {
        this.rules[styleID] = 'error';
        this.rulesPDF[styleID] = 'error';
      }
    }
  };

  createRule = (ruleObject, styleID, layer, isPDF) => {
    let self = this;
    if ((!isPDF && this.rules[styleID] === undefined) || (isPDF && this.rulesPDF[styleID] === undefined)) {
      var styleRules = [];
      var styleDependants = [];
      let scaleDenominator;
      if (ruleObject !== undefined) {
        for (let i = 0; i < ruleObject.rules.length; ++i) {
          let ruleName = ruleObject.rules[i].name;
          let symbolizers = [];
          let hasSVG = false;
          let isImg = false;
          let isRaster = false;
          if (ruleObject.rules[i].scaleDenominator) {
            scaleDenominator = ruleObject.rules[i].scaleDenominator;
            this.setScale(true);
          } else this.setScale(false);
          for (let j = 0; j < ruleObject.rules[i].symbolizers.length; ++j) {
            switch (ruleObject.rules[i].symbolizers[j].kind) {
              case 'Mark':
                let wellKnownName = ruleObject.rules[i].symbolizers[j].wellKnownName;
                if (wellKnownName === 'x' || wellKnownName === 'cross' || wellKnownName === 'triangle' || wellKnownName === 'star') hasSVG = true;
                symbolizers.push(self.getPointSymbol(ruleObject.rules[i].symbolizers[j], isPDF));
                break;
              case 'Icon':
                isImg = true;
                symbolizers.push(self.getImageSymbol(ruleObject.rules[i].symbolizers[j], isPDF));
                break;
              case 'Text':
                symbolizers.push(self.getTextSymbol(ruleObject.rules[i].symbolizers[j], isPDF));
                break;
              case 'Fill':
                symbolizers.push(self.getPolygonSymbol(ruleObject.rules[i].symbolizers[j], isPDF));
                break;
              case 'Line':
                symbolizers.push(self.getLineSymbol(ruleObject.rules[i].symbolizers[j], isPDF));
                break;
              case 'Raster':
                self.isRaster = true;
                isRaster = true;
                symbolizers.push(self.getRasterSymbol(ruleObject.rules[i].symbolizers[j], styleRules, isPDF));
                break;
              default:
                break;
            }
          }

          let noName = ruleObject.rules.find((rule) => rule.name === 'Etiquetes') && !layer.hasChildsOrRules();
          !isRaster &&
            !scaleDenominator &&
            styleRules.push(
              <>
                {isPDF ? (
                  <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                    {hasSVG ? (
                      <>{symbolizers}</>
                    ) : isImg ? (
                      <Image src={this.imgUrl} style={{ width: 10, height: 10, marginRight: 5 }} />
                    ) : (
                      <Svg style={{ width: 16, height: 16, marginRight: 5 }} viewBox="0 0 20 20">
                        {symbolizers}
                      </Svg>
                    )}
                    {ruleObject.rules.length > 1 && !noName && <Text style={{ fontSize: 8, color: 'black' }}>{ruleName}</Text>}
                  </View>
                ) : (
                  <LayerRules id={'layerRule_' + ruleName}>
                    {hasSVG ? (
                      <>{symbolizers}</>
                    ) : (
                      <SymbolSVG width="20" height="20" viewBox="0 0 20 20">
                        {symbolizers}
                      </SymbolSVG>
                    )}
                    {ruleObject.rules.length > 1 && !noName && (
                      <RuleName id={'ruleName' + ruleName} title={ruleName}>
                        {ruleName}
                      </RuleName>
                    )}
                  </LayerRules>
                )}
              </>
            );

          let rule = {
            symbolizers: symbolizers,
            hasSVG: hasSVG,
            isImg: isImg,
            imgUrl: this.imgUrl,
            ruleName: ruleName,
            scale: scaleDenominator,
            layerName: layer.getName(),
            needsTitle: noName,
            rulesLength: ruleObject.rules.length
          };

          if (scaleDenominator) styleDependants.push(rule);
        }
      }
      if (scaleDenominator) this.returnStyleDependants(styleDependants, styleRules, layer.hasChildsOrRules(), isPDF);
      isPDF === true
        ? (this.rulesPDF[styleID] = styleRules.length > 0 ? styleRules : null)
        : (this.rules[styleID] = styleRules.length > 0 ? styleRules : null);
    }
    return;
  };

  /**
   *
   * @param {*} styleDependants
   * @param {*} rules
   * @param {*} hasChilds
   * @param {*} isPDF
   * @desc funcion para obtener estilos que dependen de escala
   */
  returnStyleDependants = (styleDependants, rules, hasChilds, isPDF) => {
    let ranges = {};

    styleDependants.forEach((element) => {
      let minScale = element.scale.min;
      let maxScale = element.scale.max;
      let scaleRange = `${minScale}-${maxScale}`;
      if (!ranges[scaleRange]) {
        ranges[scaleRange] = [];
      }

      if (isPDF === true) {
        this.pdfScaleRules.push(element);
      }

      ranges[scaleRange].push(
        <>
          <LayerRules
            id={'layerRule_' + element.ruleName}
            className={minScale ? minScale + '-' + maxScale + ' ' + element.layerName : 0 + '-' + maxScale + ' ' + element.layerName}>
            {element.hasSVG ? (
              <>{element.symbolizers}</>
            ) : (
              <SymbolSVG width="20" height="20" viewBox="0 0 20 20">
                {element.symbolizers}
              </SymbolSVG>
            )}
            {element.rulesLength > 1 && !element.needsTitle && (
              <RuleName id={'ruleName' + element.ruleName} title={element.ruleName}>
                {element.ruleName}
              </RuleName>
            )}
          </LayerRules>
        </>
      );
    });

    Object.entries(ranges).forEach(([key, value]) => {
      let range = key.split('-');
      let div = (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          {hasChilds ? (
            <div
              className="Escala"
              style={{
                fontSize: '12px',
                marginTop: '10px',
                marginBottom: '5px'
              }}>
              Escala: Del {range[0] !== 'undefined' ? range[0] : 0} al {range[1]}
            </div>
          ) : (
            <></>
          )}
          {value}
        </div>
      );
      rules.push(div);
    });
  };

  /**
   *
   * @param {*} idx
   * @desc funcion para obtener la regla de estilo para el identificador id
   */
  getRule = (idx, isPDF) => {
    if (isPDF === true) {
      if (this.rulesPDF[idx] !== undefined) {
        return this.rulesPDF[idx];
      }
    } else {
      if (this.rules[idx] !== undefined) {
        return this.rules[idx];
      }
    }
    return undefined;
  };

  getPDFScale = () => {
    return this.pdfScaleRules;
  };

  /**
   * @desc funcion para saber si existe la regla de estilo para el identificador id
   */
  hasRule = (id, isPDF) => {
    if (isPDF === true) {
      return this.rulesPDF[id] !== undefined;
    } else {
      return this.rules[id] !== undefined;
    }
  };

  /**
   *
   * @param {*} symbol
   * @param {*} isPDF
   * @desc funcion para obtener un estilo de tipo punto
   */
  getPointSymbol = (symbol, isPDF) => {
    let self = this;
    switch (symbol.wellKnownName) {
      case 'circle':
        return self.getCircleSymbol(symbol, isPDF);
      case 'square':
        return self.getCircleSymbol(symbol, isPDF);
      case 'triangle':
        return self.getTriangleSymbol(symbol, isPDF);
      case 'star':
        return self.getStarSymbol(symbol, isPDF);
      case 'cross':
        return self.getCrossSymbol(symbol, isPDF);
      case 'x':
        return self.getXSymbol(symbol, isPDF);
      default:
        return self.getCircleSymbol(symbol, isPDF);
    }
  };

  /**
   *
   * @param {*} symbol
   * @param {*} isPDF
   * @desc funcion para obtener un estilo de tipo imagen
   */
  getImageSymbol = (symbol, isPDF) => {
    let size = (20 - symbol.size) / 2;

    if (symbol.image.startsWith('http:')) {
      symbol.image = symbol.image.replace('http:', 'https:');
    } else {
      // svgImg.src = symbol.image;
    }

    return isPDF ? (
      (this.imgUrl = symbol.image)
    ) : (
      <image cx="10" cy="10" r="1" x={size} y={size} width={symbol.size} height={symbol.size} href={symbol.image} />
    );
  };

  /**
   *
   * @param {*} symbol
   * @param {*} isPDF
   * @desc funcion para obtener un estilo de tipo texto
   */
  getTextSymbol = (symbol, isPDF) => {
    return isPDF ? (
      <Path
        // fill={symbol.color}
        fill="black"
        transform="scale(0.6)"
        xmlns="http://www.w3.org/2000/svg"
        d="M14.9,2h8.7v2.5h-8.7V2z M16.2,7h7.5v2.5h-7.5V7z M18.7,12h5v2.5h-5V12z M7.8,2L0.4,22H3l2.3-6.2h7.9l2.3,6.2h2.7L10.8,2  H7.8z M6.3,13.2l3-8.1l3,8.1H6.3z"
      />
    ) : (
      <path
        // fill={symbol.color}
        fill="white"
        transform="translate(3, 2), scale(0.7,0.7)"
        xmlns="http://www.w3.org/2000/svg"
        d="M14.9,2h8.7v2.5h-8.7V2z M16.2,7h7.5v2.5h-7.5V7z M18.7,12h5v2.5h-5V12z M7.8,2L0.4,22H3l2.3-6.2h7.9l2.3,6.2h2.7L10.8,2  H7.8z M6.3,13.2l3-8.1l3,8.1H6.3z"
      />
    );
  };

  getPolygonSymbol = (symbol, isPDF) => {
    let fillColor = symbol.color === '#FFFFFF' || symbol.color === '#ffffff' || symbol.color === undefined ? 'none' : symbol.color;
    //let fillColor = symbol.color === '#FFFFFF' || symbol.color === '#ffffff' ? 'none' : symbol.color === undefined ? 'black' : symbol.color;

    return isPDF ? (
      <Path
        d=" M 2,14 4,16 16,16 18,14 18,6 16,4 4,4 2,6 2,14 z"
        fillRule="evenodd"
        fill={fillColor}
        fillOpacity={symbol.fillOpacity}
        stroke={symbol.outlineColor}
        strokeWidth={symbol.outlineWidth}
        strokeOpacity={symbol.outlineOpacity}
        strokeDasharray={symbol.outlineDasharray && symbol.outlineDasharray.join(', ')}
        strokeLinecap={symbol.outlineCap}
        strokeLinejoin={symbol.outlineJoin}></Path>
    ) : (
      <path
        d=" M 2,14 4,16 16,16 18,14 18,6 16,4 4,4 2,6 2,14 z"
        fillRule="evenodd"
        fill={fillColor}
        fillOpacity={symbol.fillOpacity}
        stroke={symbol.outlineColor}
        strokeWidth={symbol.outlineWidth}
        strokeOpacity={symbol.outlineOpacity}
        strokeDasharray={symbol.outlineDasharray}
        strokeLinecap={symbol.outlineCap}
        strokeLinejoin={symbol.outlineJoin}></path>
    );
  };

  /**
   *
   * @param {*} symbol
   * @param {*} isPDF
   * @desc funcion para obtener un estilo de tipo linea
   */

  getLineSymbol = (symbol, isPDF) => {
    return isPDF ? (
      <Polyline
        points="2,13,7,7,13,13,18,7"
        stroke={symbol.color}
        fill="none"
        strokeWidth={symbol.width}
        strokeLinecap={symbol.cap}
        strokeLinejoin={symbol.join}
        strokeDasharray={symbol.dasharray && symbol.dasharray.join(', ')}
        strokeDashoffset={symbol.dashOffset}
        strokeOpacity={symbol.opacity}
      />
    ) : (
      <polyline
        points="2,13,7,7,13,13,18,7"
        stroke={symbol.color}
        fill="none"
        strokeWidth={symbol.width}
        strokeLinecap={symbol.cap}
        strokeLinejoin={symbol.join}
        strokeDasharray={symbol.dasharray}
        strokeDashoffset={symbol.dashOffset}
        strokeOpacity={symbol.opacity}
      />
    );
  };

  /**
   *
   * @param {*} symbol
   * @param {*} isPDF
   * @desc funcion para obtener un estilo de tipo raster
   */
  getRasterSymbol = (symbol, rules, isPDF) => {
    if (symbol?.colorMap && symbol?.colorMap?.colorMapEntries) {
      for (let i = 0; i < symbol?.colorMap?.colorMapEntries?.length; ++i) {
        let entry = symbol.colorMap.colorMapEntries[i];
        if (entry.color !== undefined) {
          rules.push(
            isPDF ? (
              <View>
                <Svg style={{ width: 16, height: 16, marginRight: 5 }} viewBox="0 0 20 20">
                  <Path
                    d=" M 2,14 4,16 16,16 18,14 18,6 16,4 4,4 2,6 2,14 z"
                    fillRule="evenodd"
                    fill={entry.color}
                    fillOpacity={entry.opacity}></Path>
                </Svg>
                <Text style={{ fontSize: 8, color: 'black' }}>{entry.label}</Text>
              </View>
            ) : (
              <LayerRules id={'layerRule_' + entry.label}>
                <SymbolSVG width="20" height="20" viewBox="0 0 20 20">
                  <path
                    d=" M 2,14 4,16 16,16 18,14 18,6 16,4 4,4 2,6 2,14 z"
                    fillRule="evenodd"
                    fill={entry.color}
                    fillOpacity={entry.opacity}></path>
                </SymbolSVG>
                <RuleName id={'ruleName' + entry.label} title={entry.label}>
                  {entry.label}
                </RuleName>
              </LayerRules>
            )
          );
        }
      }
    }
  };

  /**
   *
   * @param {*} symbol
   * @param {*} isPDF
   * @desc funcion para obtener un estilo de tipo triangulo
   */
  getTriangleSymbol = (symbol, isPDF) => {
    return isPDF ? (
      <Svg
        cx="10"
        cy="10"
        height="16"
        width="16"
        viewBox="-10 -10 30 30"
        r={symbol.radius}
        fill={symbol.color}
        fillOpacity={symbol.fillOpacity}
        stroke={symbol.strokeColor}
        strokeWidth={symbol.strokeWidth}
        strokeOpacity={symbol.strokeOpacity}>
        {triangleShapePDF}
      </Svg>
    ) : (
      <SymbolSVG
        cx="10"
        cy="10"
        height="20px"
        width="20px"
        viewBox="-10 -10 30 30"
        r={symbol.radius}
        fill={symbol.color}
        fillOpacity={symbol.fillOpacity}
        stroke={symbol.strokeColor}
        strokeWidth={symbol.strokeWidth}
        strokeOpacity={symbol.strokeOpacity}>
        {triangleShape}
      </SymbolSVG>
    );
  };

  /**
   *
   * @param {*} symbol
   * @param {*} isPDF
   * @desc funcion para obtener un estilo de tipo X
   */
  getXSymbol = (symbol, isPDF) => {
    return isPDF ? (
      <Svg
        cx="10"
        cy="10"
        height="16"
        width="16"
        viewBox="-100 -100 300 300"
        r={symbol.radius}
        fill={symbol.color}
        fillOpacity={symbol.fillOpacity}
        stroke={symbol.strokeColor}
        strokeWidth={symbol.strokeWidth}
        strokeOpacity={symbol.strokeOpacity}>
        {xShapePDF}
      </Svg>
    ) : (
      <SymbolSVG
        cx="10"
        cy="10"
        height="20px"
        width="20px"
        viewBox="-100 -100 300 300"
        r={symbol.radius}
        fill={symbol.color}
        fillOpacity={symbol.fillOpacity}
        stroke={symbol.strokeColor}
        strokeWidth={symbol.strokeWidth}
        strokeOpacity={symbol.strokeOpacity}>
        {xShape}
      </SymbolSVG>
    );
  };

  /**
   *
   * @param {*} symbol
   * @param {*} isPDF
   * @desc funcion para obtener un estilo de tipo estrella
   */
  getStarSymbol = (symbol, isPDF) => {
    return isPDF ? (
      <Svg
        cx="10"
        cy="10"
        height="16"
        width="16"
        viewBox="-7 -151 714 678"
        r={symbol.radius}
        fill={symbol.color}
        fillOpacity={symbol.fillOpacity}
        stroke={symbol.strokeColor}
        strokeWidth={symbol.strokeWidth}
        strokeOpacity={symbol.strokeOpacity}>
        {starShapePDF}
      </Svg>
    ) : (
      <SymbolSVG
        cx="10"
        cy="10"
        height="20px"
        width="20px"
        viewBox="-7 -151 714 678"
        r={symbol.radius}
        fill={symbol.color}
        fillOpacity={symbol.fillOpacity}
        stroke={symbol.strokeColor}
        strokeWidth={symbol.strokeWidth}
        strokeOpacity={symbol.strokeOpacity}>
        {starShape}
      </SymbolSVG>
    );
  };

  /**
   *
   * @param {*} symbol
   * @param {*} isPDF
   * @desc funcion para obtener un estilo de tipo cruz
   */
  getCrossSymbol = (symbol, isPDF) => {
    return isPDF ? (
      <Svg
        cx="10"
        cy="10"
        height="16"
        width="16"
        viewBox="-10 -10 30 30"
        r={symbol.radius}
        fill={symbol.color}
        fillOpacity={symbol.fillOpacity}
        stroke={symbol.strokeColor}
        strokeWidth={symbol.strokeWidth}
        strokeOpacity={symbol.strokeOpacity}>
        {crossShapePDF}
      </Svg>
    ) : (
      <SymbolSVG
        cx="10"
        cy="10"
        height="20px"
        width="20px"
        viewBox="-10 -10 30 30"
        r={symbol.radius}
        fill={symbol.color}
        fillOpacity={symbol.fillOpacity}
        stroke={symbol.strokeColor}
        strokeWidth={symbol.strokeWidth}
        strokeOpacity={symbol.strokeOpacity}>
        {crossShape}
      </SymbolSVG>
    );
  };

  /**
   *
   * @param {*} symbol
   * @param {*} isPDF
   * @desc funcion para obtener un estilo de tipo circulo
   */
  getCircleSymbol = (symbol, isPDF) => {
    return isPDF ? (
      <Circle
        cx="10"
        cy="10"
        r={symbol.radius}
        fill={symbol.color}
        fillOpacity={symbol.fillOpacity}
        stroke={symbol.strokeColor}
        strokeWidth={symbol.strokeWidth}
        strokeOpacity={symbol.strokeOpacity}
      />
    ) : (
      <circle
        cx="10"
        cy="10"
        r={symbol.radius}
        fill={symbol.color}
        fillOpacity={symbol.fillOpacity}
        stroke={symbol.strokeColor}
        strokeWidth={symbol.strokeWidth}
        strokeOpacity={symbol.strokeOpacity}
      />
    );
  };
}
